import { observable } from "mobx";
import { Type } from "class-transformer";
import NewAppendixListItemGlobal from "./newAppendixListItemGlobal";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class NewAppendixListGlobal {
  @observable
  total!: number;

  @observable
  @Type(() => NewAppendixListItemGlobal)
  appendixes!: NewAppendixListItemGlobal[];

  static ValidationRules = {
    total: { required: true, number: true },
    appendixes: { required: true },
  };
}
